import { enableProdMode } from '@angular/core';
import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';
import { EnvironmentType } from '@fleet-beat/core';

import { AppModule } from './app/app.module';
import { environment } from './environments/environment';

/* eslint-disable */
if ([EnvironmentType.PROD, EnvironmentType.STAGE, EnvironmentType.DEMO].includes(environment.type)) {
  enableProdMode();
}

platformBrowserDynamic()
  .bootstrapModule(AppModule)
  .catch((err) => console.error(err));
